import type { MarketType } from '@ps/isp-web-services-types';

export const oddsBoostMarketTypes = ['DAILY_POWER_PRICES'];
export const requestABetMarketTypes = [
  'PRE_MATCH_COMBO_-_UP_TO_9/1',
  'PRE_MATCH_COMBO_-_10/1_TO_24/1',
  'PRE_MATCH_COMBO_-_25/1_TO_79/1',
  'PRE_MATCH_COMBO_-_80/1_+'
];
export const featuredRequestABetMarketTypes = ['PRE_MATCH_COMBO_-_FEATURED'];

export const isTranslatableMarketType = (marketType: MarketType) =>
  [...oddsBoostMarketTypes, ...featuredRequestABetMarketTypes].includes(marketType);
